import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { Modal } from '@/shared/ui';

interface IProps {
  open: boolean;
  title: string;
  description: React.ReactNode;
  /** Текст кнопки подтверждения; по умолчанию — «Да». */
  confirmText?: string;
  /** Подтверждение необратимо и разрушительно — красная кнопка. */
  danger?: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
  children?: React.ReactNode;
}

/**
 * Подтверждение действия: описание и «Отмена» / «Да». Пока действие выполняется,
 * модалку не закрыть — иначе непонятно, прошло ли оно.
 */
const ConfirmModal: React.FC<IProps> = ({
  open,
  title,
  description,
  confirmText,
  danger,
  loading,
  onConfirm,
  onClose,
  children
}) => {
  const { t } = useTranslation();
  const close = (): void => {
    if (!loading) onClose();
  };

  return (
    <Modal open={open} title={title} onClose={close}>
      {({ classes }) => (
        <div className={classes.form}>
          <Typography.Text>{description}</Typography.Text>
          {children}
          <div className={classes.actions}>
            <Button onClick={close}>{t('common.cancel')}</Button>
            <Button
              type="primary"
              danger={danger}
              loading={loading}
              onClick={onConfirm}
            >
              {confirmText ?? t('common.yes')}
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ConfirmModal;
